import { useState, useRef, useEffect, useCallback } from 'react'
import gsap from 'gsap'

const PREVIEWS = [
  {
    name: 'PURPLE', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee78dd0f5cfb4075ad5f8d/1777236191133/BeforePB_02-1.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee788d4583922c02bcb2c5/1777236117966/AfterPB_02.jpg',
  },
  {
    name: 'BLUE', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee788db110a143d1d84b46/1777236114783/BBlue-3.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee78547607771884822780/1777236055202/ABlue-3.jpg',
  },
  {
    name: 'LABRINTH', sub: 'Cinematic Concert',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee88cdbf2e1200b32d190e/1777240270094/_MAH8440.JPG.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee88d00038cd5c6bd7a389/1777240273430/_MAH84402.JPG.jpg',
  },
  {
    name: 'RED', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee79eefcf10243dbd9da8b/1777236463720/BeforeRed07-2.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee7a0c252771215793fdff/1777236496725/AfterRed_07-2.jpg',
  },
  {
    name: 'BLUE II', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee788dc793c279a2492694/1777236112337/BBlue-2.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee7854fc2c2d2c78238c26/1777236054348/ABlue-2.jpg',
  },
  {
    name: 'CHAPPELL ROAN', sub: 'Cinematic Concert',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee886e48cbdf512b3d35ab/1777240177059/_MAH7246-Enhanced-NR.JPG.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee88acbbad736f06caab54/1777240238418/_MAH7246-Enhanced-NR2.JPG.jpg',
  },
  {
    name: 'PURPLE II', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee79968c978d6246a650f7/1777236378899/BPurple-1.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee7996053aed54d37ead96/1777236403155/APurple-1.jpg',
  },
  {
    name: 'PINK', sub: 'Color Correction',
    before: 'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee7a2cb110a143d1d8dec9/1777236526594/BeforePink_01-1.jpg',
    after:  'https://static1.squarespace.com/static/61461a32bf91ca2c3266e5e9/t/69ee7a410038cd5c6bd2e0b4/1777236558058/AfterPink_01.jpg',
  },
]

// Decorative adjustment slider
function AdjSlider({ name, value }) {
  return (
    <div style={{ marginBottom: 9 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
        <span style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 8.5, color: 'rgba(242,239,232,0.40)', letterSpacing: '0.06em' }}>{name}</span>
        <span style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 8.5, color: 'rgba(242,239,232,0.25)', letterSpacing: '0.04em' }}>{value > 50 ? `+${value - 50}` : value < 50 ? `${value - 50}` : '0'}</span>
      </div>
      <div style={{ height: 2, background: 'rgba(255,255,255,0.08)', borderRadius: 1, position: 'relative' }}>
        <div style={{ position: 'absolute', left: '50%', width: `${Math.abs(value - 50) * 2}%`, height: '100%', background: 'rgba(255,42,31,0.50)', borderRadius: 1, transform: value >= 50 ? 'translateX(0)' : `translateX(-${Math.abs(value - 50) * 2}%)` }} />
        <div style={{ position: 'absolute', left: `${value}%`, top: '50%', transform: 'translate(-50%, -50%)', width: 7, height: 7, background: '#d8d4cc', borderRadius: '50%', boxShadow: '0 1px 3px rgba(0,0,0,0.6)' }} />
      </div>
    </div>
  )
}

// Simple histogram bars (decorative)
function Histogram() {
  const bars = [4, 7, 12, 18, 28, 38, 52, 68, 72, 65, 54, 42, 30, 20, 14, 9, 6, 4, 3, 2]
  const max = Math.max(...bars)
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 1, height: 36, marginBottom: 12 }}>
      {bars.map((v, i) => (
        <div key={i} style={{
          flex: 1,
          height: `${(v / max) * 100}%`,
          background: `rgba(${i < 6 ? '120,160,220' : i < 13 ? '180,180,180' : '220,140,100'},0.55)`,
          borderRadius: '1px 1px 0 0',
        }} />
      ))}
    </div>
  )
}

export default function SceneStore({ width = 1440, height = 900, isMobile = false }) {
  const [selectedIdx, setSelectedIdx] = useState(0)
  const [split, setSplit] = useState(50)
  const [hasDragged, setHasDragged] = useState(false)

  const sliderRef  = useRef(null)
  const isDragging = useRef(false)
  const hasRevealed = useRef(false)
  const splitRef   = useRef({ value: 50 })
  const gsapTweenRef = useRef(null)
  const containerRef = useRef(null)

  const preset = PREVIEWS[selectedIdx]

  const updateSplit = useCallback((clientX) => {
    if (!sliderRef.current) return
    const rect = sliderRef.current.getBoundingClientRect()
    const pct = Math.min(98, Math.max(2, ((clientX - rect.left) / rect.width) * 100))
    setSplit(pct)
    splitRef.current.value = pct
  }, [])

  const runRevealAnimation = useCallback((fromValue, toValue, duration) => {
    if (gsapTweenRef.current) gsapTweenRef.current.kill()
    splitRef.current.value = fromValue
    setSplit(fromValue)
    gsapTweenRef.current = gsap.to(splitRef.current, {
      value: toValue, duration, ease: 'power2.out',
      onUpdate: () => setSplit(Math.round(splitRef.current.value)),
    })
  }, [])

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReduced) return
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasRevealed.current) {
          hasRevealed.current = true
          observer.disconnect()
          runRevealAnimation(8, 50, 1.4)
        }
      })
    }, { threshold: 0.3 })
    if (containerRef.current) observer.observe(containerRef.current)
    return () => observer.disconnect()
  }, [runRevealAnimation])

  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) { isFirstRender.current = false; return }
    runRevealAnimation(8, 50, 1.1)
  }, [selectedIdx, runRevealAnimation])

  useEffect(() => {
    const onMouseMove = (e) => { if (isDragging.current) updateSplit(e.clientX) }
    const onMouseUp   = ()  => { isDragging.current = false }
    window.addEventListener('mousemove', onMouseMove)
    window.addEventListener('mouseup', onMouseUp)
    return () => {
      window.removeEventListener('mousemove', onMouseMove)
      window.removeEventListener('mouseup', onMouseUp)
    }
  }, [updateSplit])

  const handleMouseDown = (e) => {
    isDragging.current = true
    if (!hasDragged) setHasDragged(true)
    updateSplit(e.clientX)
  }

  // Adjustment values per preset (decorative) — order matches PREVIEWS: Chappell, Labrinth, Red, Pink, Blue, Blue II, Purple
  const ADJ = [
    { exp: 52, con: 50, hi: 40, sh: 60, wh: 50, bl: 50, temp: 56, tint: 42, vib: 62, sat: 56 }, // Purple
    { exp: 56, con: 42, hi: 45, sh: 55, wh: 60, bl: 48, temp: 44, tint: 56, vib: 60, sat: 58 }, // Blue
    { exp: 62, con: 48, hi: 42, sh: 66, wh: 52, bl: 44, temp: 38, tint: 50, vib: 70, sat: 62 }, // Labrinth
    { exp: 50, con: 60, hi: 30, sh: 70, wh: 45, bl: 55, temp: 35, tint: 48, vib: 55, sat: 50 }, // Red
    { exp: 58, con: 46, hi: 40, sh: 58, wh: 54, bl: 50, temp: 46, tint: 52, vib: 56, sat: 54 }, // Blue II
    { exp: 54, con: 56, hi: 35, sh: 58, wh: 48, bl: 53, temp: 60, tint: 45, vib: 58, sat: 55 }, // Chappell Roan
    { exp: 48, con: 58, hi: 36, sh: 64, wh: 46, bl: 54, temp: 60, tint: 36, vib: 66, sat: 60 }, // Purple II
    { exp: 53, con: 52, hi: 38, sh: 64, wh: 47, bl: 52, temp: 40, tint: 58, vib: 68, sat: 63 }, // Pink
  ]
  const adj = ADJ[selectedIdx]

  // ── Mobile layout: full-screen before/after + preset strip + CTA ──────────
  if (isMobile) {
    return (
      <div style={{ width: '100%', height: '100%', background: '#080808', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Header */}
        <div style={{
          padding: '14px 20px 10px',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexShrink: 0, borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div className="mono" style={{ color: 'var(--bone-50)', fontSize: 10, display: 'flex', gap: 10, alignItems: 'center' }}>
            <span style={{ color: 'var(--red)' }}>07</span>
            <span style={{ width: 22, height: 1, background: 'var(--bone-30)', display: 'inline-block' }} />
            STORE
          </div>
          <a
            href="https://www.drewhalle.com/store"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontFamily: 'var(--font-mono)', fontSize: 9, letterSpacing: '0.14em',
              textTransform: 'uppercase', color: '#fff', textDecoration: 'none',
              background: '#ff2a1f', borderRadius: 2, padding: '7px 14px',
              boxShadow: '0 2px 10px rgba(255,42,31,0.35)',
            }}
          >
            VISIT STORE →
          </a>
        </div>

        {/* Before/after slider — fills the main area */}
        <div
          ref={sliderRef}
          onTouchMove={(e) => { if (!hasDragged) setHasDragged(true); updateSplit(e.touches[0].clientX); }}
          style={{ flex: 1, position: 'relative', overflow: 'hidden', background: '#111', cursor: 'ew-resize' }}
        >
          <img src={preset.after} alt="After" draggable={false}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain', userSelect: 'none', pointerEvents: 'none' }} />
          <img src={preset.before} alt="Before" draggable={false}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain', clipPath: `inset(0 ${100 - split}% 0 0)`, zIndex: 2, userSelect: 'none', pointerEvents: 'none' }} />

          {/* Divider + handle */}
          <div style={{ position: 'absolute', top: 0, bottom: 0, left: `${split}%`, width: 1, background: 'rgba(255,255,255,0.70)', zIndex: 5, pointerEvents: 'none', boxShadow: '0 0 6px rgba(255,255,255,0.3)' }} />
          <div style={{
            position: 'absolute', left: `${split}%`, top: '50%',
            transform: 'translate(-50%, -50%)',
            width: 32, height: 32, borderRadius: '50%',
            background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.55)',
            zIndex: 6, display: 'flex', alignItems: 'center', justifyContent: 'center',
            pointerEvents: 'none',
          }}>
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
              <path d="M5 5H1M1 5L3.5 2.5M1 5L3.5 7.5" stroke="#444" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M11 5H15M15 5L12.5 2.5M15 5L12.5 7.5" stroke="#444" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          {/* Labels */}
          <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 5, fontFamily: 'var(--font-mono)', fontSize: 8, letterSpacing: '0.22em', color: 'rgba(255,255,255,0.55)', background: 'rgba(0,0,0,0.4)', padding: '3px 6px', borderRadius: 2, pointerEvents: 'none' }}>BEFORE</div>
          <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 5, fontFamily: 'var(--font-mono)', fontSize: 8, letterSpacing: '0.22em', color: 'rgba(255,255,255,0.55)', background: 'rgba(0,0,0,0.4)', padding: '3px 6px', borderRadius: 2, pointerEvents: 'none' }}>AFTER</div>

          {/* Preset name */}
          <div style={{ position: 'absolute', bottom: 12, left: 12, zIndex: 5, pointerEvents: 'none' }}>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 18, color: '#f2efe8', textTransform: 'uppercase', letterSpacing: '-0.02em', textShadow: '0 2px 10px rgba(0,0,0,0.8)' }}>{preset.name}</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 8, color: 'rgba(255,42,31,0.80)', letterSpacing: '0.22em', marginTop: 4 }}>{preset.sub.toUpperCase()}</div>
          </div>

          {!hasDragged && (
            <div style={{ position: 'absolute', bottom: 14, left: '50%', transform: 'translateX(-50%)', fontFamily: 'var(--font-mono)', fontSize: 7.5, letterSpacing: '0.22em', color: 'rgba(255,255,255,0.35)', background: 'rgba(0,0,0,0.45)', padding: '4px 10px', borderRadius: 2, zIndex: 5, whiteSpace: 'nowrap', pointerEvents: 'none' }}>DRAG TO COMPARE</div>
          )}
        </div>

        {/* Preset thumbnails strip */}
        <div style={{
          height: 68, background: '#161616',
          borderTop: '1px solid rgba(255,255,255,0.07)',
          display: 'flex', alignItems: 'center',
          padding: '0 12px', gap: 6,
          overflowX: 'auto', flexShrink: 0,
          WebkitOverflowScrolling: 'touch',
        }}>
          {PREVIEWS.map((p, i) => {
            const isActive = i === selectedIdx;
            return (
              <button
                key={p.name}
                onClick={() => setSelectedIdx(i)}
                style={{
                  flexShrink: 0, width: 60, height: 42, padding: 0,
                  border: isActive ? '1.5px solid rgba(255,42,31,0.85)' : '1px solid rgba(255,255,255,0.10)',
                  borderRadius: 2, overflow: 'hidden', cursor: 'pointer',
                  background: '#111',
                  boxShadow: isActive ? '0 0 8px rgba(255,42,31,0.28)' : 'none',
                  position: 'relative',
                }}
              >
                <img src={p.after} alt={p.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', filter: isActive ? 'brightness(0.85)' : 'brightness(0.5)' }} />
                <div style={{
                  position: 'absolute', bottom: 0, left: 0, right: 0,
                  fontFamily: 'var(--font-mono)', fontSize: 5.5, letterSpacing: '0.06em',
                  textTransform: 'uppercase',
                  color: isActive ? '#f2efe8' : 'rgba(242,239,232,0.45)',
                  background: 'rgba(0,0,0,0.55)', padding: '2px 3px', textAlign: 'center',
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                }}>{p.name}</div>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      style={{ position: 'relative', width, height, background: '#080808', overflow: 'hidden' }}
    >
      {/* Subtle background grain */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0,
        opacity: 0.025,
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")",
        backgroundSize: '200px', mixBlendMode: 'overlay',
      }} />

      {/* Page header */}
      <div style={{
        position: 'absolute', top: 40, left: 64, right: 64, zIndex: 30,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <div className="mono" style={{ color: 'var(--bone-50)', display: 'flex', gap: 16, alignItems: 'center' }}>
          <span style={{ color: 'var(--red)' }}>07</span>
          <span style={{ width: 40, height: 1, background: 'var(--bone-30)', display: 'inline-block' }} />
          STORE
        </div>
        <div className="mono" style={{ color: 'var(--bone-30)', fontSize: 9, letterSpacing: '0.16em' }}>
          LIGHTROOM PRESETS · CONCERT PHOTOGRAPHY
        </div>
      </div>

      {/* ── Software window ─────────────────────────────────────────────────── */}
      <div style={{
        position: 'absolute',
        left: 64, right: 64, top: 82, bottom: 28,
        borderRadius: 10,
        background: '#1a1a1a',
        border: '1px solid rgba(255,255,255,0.08)',
        boxShadow: '0 32px 80px rgba(0,0,0,0.75), 0 8px 24px rgba(0,0,0,0.55)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        zIndex: 10,
      }}>

        {/* ── Title bar ───────────────────────────────────────────────────── */}
        <div style={{
          height: 38,
          background: '#222',
          borderBottom: '1px solid rgba(255,255,255,0.07)',
          display: 'flex',
          alignItems: 'center',
          padding: '0 14px',
          gap: 12,
          flexShrink: 0,
        }}>
          {/* macOS traffic lights */}
          <div style={{ display: 'flex', gap: 7, alignItems: 'center' }}>
            {['#ff5f57','#ffbd2e','#28c840'].map((c, i) => (
              <div key={i} style={{ width: 12, height: 12, borderRadius: '50%', background: c, opacity: 0.9 }} />
            ))}
          </div>
          {/* Window title */}
          <div style={{ flex: 1, textAlign: 'center' }}>
            <span style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 10, color: 'rgba(242,239,232,0.38)', letterSpacing: '0.14em' }}>
              PRESET STUDIO  ·  {preset.name}  /  {preset.sub.toUpperCase()}
            </span>
          </div>
          {/* Decorative window controls */}
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {[0,1,2].map(i => (
              <div key={i} style={{ width: 22, height: 14, borderRadius: 2, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.07)' }} />
            ))}
          </div>
        </div>

        {/* ── Main workspace ──────────────────────────────────────────────── */}
        <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>

          {/* Left toolbar (decorative) */}
          <div style={{
            width: 46,
            background: '#1e1e1e',
            borderRight: '1px solid rgba(255,255,255,0.06)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 14,
            gap: 18,
            flexShrink: 0,
          }}>
            {/* Tool icons */}
            {[
              // Cursor
              <svg key="cur" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 2l10 6-5 1-2 5L3 2z" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2" strokeLinejoin="round"/></svg>,
              // Crop
              <svg key="crp" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="3" y="3" width="10" height="10" rx="1" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2"/><line x1="1" y1="5" x2="3" y2="5" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2"/><line x1="11" y1="13" x2="15" y2="13" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2"/></svg>,
              // Heal
              <svg key="hel" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="5" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2"/><circle cx="8" cy="8" r="2" stroke="rgba(242,239,232,0.4)" strokeWidth="1"/></svg>,
              // Eye
              <svg key="eye" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 8c2-4 12-4 14 0-2 4-12 4-14 0z" stroke="rgba(242,239,232,0.4)" strokeWidth="1.2"/><circle cx="8" cy="8" r="2.5" stroke="rgba(242,239,232,0.4)" strokeWidth="1"/></svg>,
              // Gradient
              <svg key="grd" width="16" height="16" viewBox="0 0 16 16" fill="none"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="rgba(242,239,232,0.55)"/><stop offset="100%" stopColor="rgba(242,239,232,0.1)"/></linearGradient></defs><rect x="2" y="5" width="12" height="6" rx="1" fill="url(#g)"/></svg>,
            ].map((icon, i) => (
              <div key={i} style={{ cursor: 'default', padding: 5, borderRadius: 4, background: i === 0 ? 'rgba(255,42,31,0.15)' : 'transparent' }}>
                {icon}
              </div>
            ))}
          </div>

          {/* ── Center: Before/after canvas ─────────────────────────────── */}
          <div
            ref={sliderRef}
            onMouseDown={handleMouseDown}
            onTouchMove={(e) => { if (!hasDragged) setHasDragged(true); updateSplit(e.touches[0].clientX) }}
            style={{
              flex: 1,
              background: '#111',
              position: 'relative',
              overflow: 'hidden',
              cursor: 'ew-resize',
              minWidth: 0,
            }}
          >
            {/* AFTER image — base layer, always visible on right side */}
            <img
              src={preset.after}
              alt="After"
              draggable={false}
              style={{
                position: 'absolute', inset: 0,
                width: '100%', height: '100%',
                objectFit: 'contain',
                userSelect: 'none', pointerEvents: 'none',
              }}
            />

            {/* BEFORE image — clipped layer, reveals on left as user drags */}
            <img
              src={preset.before}
              alt="Before"
              draggable={false}
              style={{
                position: 'absolute', inset: 0,
                width: '100%', height: '100%',
                objectFit: 'contain',
                clipPath: `inset(0 ${100 - split}% 0 0)`,
                zIndex: 2,
                userSelect: 'none', pointerEvents: 'none',
              }}
            />

            {/* Divider line */}
            <div style={{
              position: 'absolute', top: 0, bottom: 0,
              left: `${split}%`,
              width: 1,
              background: 'rgba(255,255,255,0.70)',
              zIndex: 5,
              pointerEvents: 'none',
              boxShadow: '0 0 6px rgba(255,255,255,0.3)',
            }} />

            {/* Handle knob */}
            <div style={{
              position: 'absolute',
              left: `${split}%`,
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: 28, height: 28,
              borderRadius: '50%',
              background: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.55)',
              zIndex: 6,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              pointerEvents: 'none',
            }}>
              <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
                <path d="M5 5H1M1 5L3.5 2.5M1 5L3.5 7.5" stroke="#444" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11 5H15M15 5L12.5 2.5M15 5L12.5 7.5" stroke="#444" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* BEFORE label — left side */}
            <div style={{
              position: 'absolute', top: 10, left: 12, zIndex: 5,
              fontFamily: 'var(--font-mono, monospace)', fontSize: 8,
              letterSpacing: '0.22em', textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.50)', pointerEvents: 'none',
              background: 'rgba(0,0,0,0.35)', padding: '3px 6px', borderRadius: 2,
            }}>BEFORE</div>

            {/* AFTER label — right side */}
            <div style={{
              position: 'absolute', top: 10, right: 12, zIndex: 5,
              fontFamily: 'var(--font-mono, monospace)', fontSize: 8,
              letterSpacing: '0.22em', textTransform: 'uppercase',
              color: 'rgba(255,255,255,0.50)', pointerEvents: 'none',
              background: 'rgba(0,0,0,0.35)', padding: '3px 6px', borderRadius: 2,
            }}>AFTER</div>

            {/* Drag hint */}
            {!hasDragged && (
              <div style={{
                position: 'absolute', bottom: 12, left: '50%',
                transform: 'translateX(-50%)',
                fontFamily: 'var(--font-mono, monospace)', fontSize: 7.5,
                letterSpacing: '0.22em', textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.35)', pointerEvents: 'none',
                zIndex: 5, whiteSpace: 'nowrap',
                background: 'rgba(0,0,0,0.40)', padding: '4px 10px', borderRadius: 2,
              }}>DRAG TO COMPARE</div>
            )}
          </div>

          {/* ── Right adjustments panel ─────────────────────────────────── */}
          <div style={{
            width: 228,
            background: '#1c1c1c',
            borderLeft: '1px solid rgba(255,255,255,0.06)',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
            overflowY: 'auto',
          }}>
            {/* Histogram */}
            <div style={{ padding: '14px 14px 0' }}>
              <div style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 8, letterSpacing: '0.18em', color: 'rgba(242,239,232,0.25)', marginBottom: 8, textTransform: 'uppercase' }}>Histogram</div>
              <Histogram />
              <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 12 }} />
            </div>

            {/* Light section */}
            <div style={{ padding: '0 14px 10px' }}>
              <div style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 8, letterSpacing: '0.18em', color: 'rgba(255,42,31,0.70)', marginBottom: 10, textTransform: 'uppercase' }}>Light</div>
              <AdjSlider name="Exposure"   value={adj.exp} />
              <AdjSlider name="Contrast"   value={adj.con} />
              <AdjSlider name="Highlights" value={adj.hi}  />
              <AdjSlider name="Shadows"    value={adj.sh}  />
              <AdjSlider name="Whites"     value={adj.wh}  />
              <AdjSlider name="Blacks"     value={adj.bl}  />
            </div>

            <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', margin: '0 14px 10px' }} />

            {/* Color section */}
            <div style={{ padding: '0 14px 14px' }}>
              <div style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 8, letterSpacing: '0.18em', color: 'rgba(255,42,31,0.70)', marginBottom: 10, textTransform: 'uppercase' }}>Color</div>
              <AdjSlider name="Temp"       value={adj.temp} />
              <AdjSlider name="Tint"       value={adj.tint} />
              <AdjSlider name="Vibrance"   value={adj.vib}  />
              <AdjSlider name="Saturation" value={adj.sat}  />
            </div>
          </div>
        </div>

        {/* ── Bottom filmstrip + CTA ───────────────────────────────────── */}
        <div style={{
          height: 76,
          background: '#161616',
          borderTop: '1px solid rgba(255,255,255,0.07)',
          display: 'flex',
          alignItems: 'center',
          padding: '0 14px',
          gap: 10,
          flexShrink: 0,
        }}>
          {/* Preset thumbnails */}
          <div style={{ display: 'flex', gap: 5, flex: 1, alignItems: 'center', overflowX: 'auto' }}>
            {PREVIEWS.map((p, i) => {
              const active = i === selectedIdx
              return (
                <button
                  key={p.name}
                  onClick={() => setSelectedIdx(i)}
                  aria-label={`Select ${p.name} preset`}
                  style={{
                    flexShrink: 0,
                    width: 70,
                    height: 48,
                    padding: 0,
                    border: active ? '1.5px solid rgba(255,42,31,0.80)' : '1px solid rgba(255,255,255,0.10)',
                    borderRadius: 3,
                    overflow: 'hidden',
                    cursor: 'pointer',
                    position: 'relative',
                    background: '#111',
                    boxShadow: active ? '0 0 10px rgba(255,42,31,0.25)' : 'none',
                    transition: 'border-color 200ms, box-shadow 200ms',
                  }}
                >
                  <img
                    src={p.after}
                    alt={p.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', filter: active ? 'brightness(0.85)' : 'brightness(0.55)', transition: 'filter 200ms' }}
                  />
                  <div style={{
                    position: 'absolute', bottom: 0, left: 0, right: 0,
                    fontFamily: 'var(--font-mono, monospace)', fontSize: 6,
                    letterSpacing: '0.08em', textTransform: 'uppercase',
                    color: active ? '#f2efe8' : 'rgba(242,239,232,0.5)',
                    background: 'rgba(0,0,0,0.55)',
                    padding: '2px 4px',
                    textAlign: 'center',
                    transition: 'color 200ms',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  }}>{p.name}</div>
                </button>
              )
            })}
          </div>

          {/* Divider */}
          <div style={{ width: 1, height: 44, background: 'rgba(255,255,255,0.08)', flexShrink: 0 }} />

          {/* VISIT STORE button */}
          <a
            href="https://www.drewhalle.com/store"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flexShrink: 0,
              fontFamily: 'var(--font-mono, monospace)',
              fontSize: 9,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              color: '#fff',
              textDecoration: 'none',
              background: '#ff2a1f',
              border: '1px solid rgba(255,42,31,0.8)',
              borderRadius: 3,
              padding: '9px 20px',
              whiteSpace: 'nowrap',
              transition: 'background 180ms ease, box-shadow 180ms ease',
              boxShadow: '0 2px 12px rgba(255,42,31,0.35)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#e0241a';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(255,42,31,0.55)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ff2a1f';
              e.currentTarget.style.boxShadow = '0 2px 12px rgba(255,42,31,0.35)';
            }}
          >
            VISIT STORE →
          </a>
        </div>
      </div>
    </div>
  )
}
